define('validation--counter-questions',["exports"], function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function () {
        var questions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];


        if (!Array.isArray(questions)) {
            return false;
        }

        return questions.length && questions.length === questions.filter(function (o) {
            var node = document.getElementById(o.id);
            return node && node.value && node.value.trim() ? true : false;
        }).length ? true : false;
    };
});
